import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import CGMStatusCardTemplate from "./CGMStatusCardTemplate";
import Button from "src/components/app/Button";

import CGMExpiredStatus from "src/assets/images/cgm/status/cgm-expired-status.png";
import { POST_MESSAGE_EVENTS } from "src/constants/common";
import { sendMessageToParent } from "src/helpers/common";

interface CGMExpiredStatusCardProps {
  color: string;
  bgColor?: string;
  label: string;
}

const CGMExpiredStatusCard: React.FC<CGMExpiredStatusCardProps> = ({
  color,
  bgColor,
  label,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const supportProgramKey = params["support-program-key"] ?? "";

  return (
    <CGMStatusCardTemplate
      image={CGMExpiredStatus}
      color={color}
      bgColor={bgColor}
      label={label}
      description={
        <div>
          <p className="text-xs mb-4">
            Remove the transmitter and{" "}
            <span className="font-semibold">place it in the charging pod.</span>{" "}
            Install a new sensor to continue tracking.
          </p>
          <Button
            variant="contained"
            color="primary"
            rounded="full"
            fullWidth
            onClick={() =>
              navigate(`/app/${supportProgramKey}/cgm-connection?restart=true`)
            }
          >
            Install new CGM
          </Button>
        </div>
      }
      bottomContent={
        <p className="text-sm text-gray-500 text-center">
          Need a new CGM or sensors?{" "}
          <span
            className="text-[var(--app-primary)] font-semibold underline cursor-pointer"
            onClick={() => {
              const data = {
                title: "Buy CGM",
                link: "https://shop.goodflip.in/products/goodflip-smart-cgm-device",
              };
              sendMessageToParent(POST_MESSAGE_EVENTS.OPEN_EXTERNAL_LINK, data);
            }}
          >
            Buy CGM
          </span>
        </p>
      }
    />
  );
};

export default CGMExpiredStatusCard;
